"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiImagePickerContext = void 0;
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var SelectButton_1 = __importDefault(require("./components/SelectButton"));
var Thumb_1 = __importDefault(require("./components/Thumb"));
var Thumbs_1 = __importDefault(require("./components/Thumbs"));
exports.MultiImagePickerContext = react_1.createContext({});
exports.MultiImagePickerContext.displayName = "MultiImagePickerContext";
function MultiImagePicker(_a) {
    var _b = _a.images, images = _b === void 0 ? [] : _b, setImages = _a.setImages, options = _a.options, onDropRejected = _a.onDropRejected, cleanupUrl = _a.cleanupUrl, children = _a.children;
    var _c = react_dropzone_1.useDropzone(__assign(__assign({}, options), { accept: "image/*", onDrop: function (acceptedFiles) {
            var droppedImages = acceptedFiles.map(function (image, index) {
                return {
                    _id: image.name + "-" + index,
                    file: Object.assign(image, {
                        preview: URL.createObjectURL(image),
                    }),
                };
            });
            setImages(__spreadArrays(images, droppedImages));
        },
        onDropRejected: function (event) {
            onDropRejected && onDropRejected(event);
        } })), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps;
    function removeImage(selectedImage) {
        setImages(images.filter(function (image) {
            if (image.file) {
                return selectedImage.file
                    ? selectedImage.file.name !== image.file.name
                    : true;
            }
            return selectedImage._id !== image._id;
        }));
    }
    react_1.useEffect(function () { return function () {
        !cleanupUrl &&
            images.forEach(function (image) {
                image.file && URL.revokeObjectURL(image.file.preview);
            });
    }; }, [images, cleanupUrl]);
    return (react_1.default.createElement(exports.MultiImagePickerContext.Provider, { value: { getInputProps: getInputProps, getRootProps: getRootProps, removeImage: removeImage } }, children));
}
exports.default = MultiImagePicker;
MultiImagePicker.SelectButton = SelectButton_1.default;
MultiImagePicker.Thumbs = Thumbs_1.default;
MultiImagePicker.Thumb = Thumb_1.default;
//# sourceMappingURL=index.js.map